import React from "react";

const insurers = [
  "OTHER", "ACKO GENERAL INSURANCE", "DHFL GIC", "ZUNO GENERAL INSURANCE",
  "NATIONAL INSURANCE", "ORIENTAL INSURANCE", "UNIVERSAL SOMPO", "MAGMA HDI",
  "ROYAL SUNDRAM", "LIBERTY GIC", "SHRIRAM GIC", "CHOLA MS", "NIVA BUPA",
  "CARE HEALTH", "ZURICH KOTAK GIC", "FUTURE GENERALI", "RELIANCE GIC",
  "GO DIGIT GIC", "SBI GENERAL INSURANCE", "NEW INDIA ASSURANCE",
  "UNITED INDIA INSURANCE", "IFFCO TOKIO", "ICICI LOMBARD", "TATA AIG",
  "HDFC ERGO", "BAJAJ ALLIANZ"
].sort();

const InsurerSelect = ({ value, onChange }) => {
  return (
    <select
      value={value}
      onChange={onChange}
      className="w-full h-[55px] bg-gray-100 border border-gray-300 text-gray-700 text-base rounded-lg px-4 focus:outline-none focus:ring-2 focus:ring-[#21A6E9] transition"
    >
      <option value="">Select Insurer</option>
      {insurers.map((insurer) => (
        <option key={insurer} value={insurer}>
          {insurer}
        </option>
      ))}
    </select>
  );
};

export default InsurerSelect;
